module.exports = __webpack_public_path__ + "media/images/icons/back-08de74464a8335880bf133d0ab024f9a.svg";